type ButtonDetails<T extends string> = {
  id: T;
  label: string;
  selected?: boolean;
};

export const budgetTypeButtons: ButtonDetails<
  'daily' | 'weekly' | 'monthly' | 'custom'
>[] = [
  {
    id: 'daily',
    label: 'Daily'
  },
  {
    id: 'weekly',
    label: 'Weekly'
  },
  {
    id: 'monthly',
    label: 'Monthly'
  },
  {
    id: 'custom',
    label: 'One time'
  }
];

export const applicableWeekdaysButtons: ButtonDetails<
  'Mon' | 'Tue' | 'Wed' | 'Thu' | 'Fri' | 'Sat' | 'Sun'
>[] = [
  {
    id: 'Mon',
    label: 'Mon'
  },
  {
    id: 'Tue',
    label: 'Tue'
  },
  {
    id: 'Wed',
    label: 'Wed'
  },
  {
    id: 'Thu',
    label: 'Thu'
  },
  {
    id: 'Fri',
    label: 'Fri'
  },
  {
    id: 'Sat',
    label: 'Sat'
  },
  {
    id: 'Sun',
    label: 'Sun'
  }
];

export const applicableEmployeeDepartment: ButtonDetails<'group' | 'user'>[] = [
  {
    id: 'group',
    label: 'By departments'
  },
  {
    id: 'user',
    label: 'By individuals'
  }
];

export const serviceTypeButtons: ButtonDetails<
  'is_restaurant' | 'is_shop' | 'is_catering'
>[] = [
  {
    id: 'is_restaurant',
    label: 'Restaurants'
  },
  {
    id: 'is_shop',
    label: 'Shops'
  },
  {
    id: 'is_catering',
    label: 'Catering'
  }
];

export const collectionTypeButtons: ButtonDetails<
  'is_delivery' | 'is_pickup'
>[] = [
  {
    id: 'is_delivery',
    label: 'Delivery'
  },
  {
    id: 'is_pickup',
    label: 'Pick-up'
  }
];

export const allowanceStatusButtons: ButtonDetails<
  'active' | 'inactive' | 'deleted' | 'expired'
>[] = [
  {
    id: 'active',
    label: 'Active'
  }
];
